export default __webpack_public_path__ + "static/blob14-9f45f54f9a29cce46c162e2891ceb863.svg";